import { createSelector } from '@ngrx/store';
import { Project } from '@rappider/rappider-sdk';

export const getActiveProjectDataSelector = createSelector(
  state => state['activeProject']?.data,
  (activeProject: Project) => activeProject
);
